import { AnswerSubCategoryDetail } from "@/schema/console/checking-assessments/AnswerSubCategoryDetail";
import AnswerRadioGroup from "@/src/console/(auth)/_components/CheckingAssessment/AnswerContent/AnswerRadioGroup";
import AssessorCheckItem from "@/src/console/(auth)/_components/CheckingAssessment/AnswerContent/AssessorCheckItem";
import { useController, useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface AnswerContentProps {
  index: number;
}

function AnswerContent({ index }: AnswerContentProps) {
  const { control } = useFormContext<AnswerSubCategoryDetail>();
  const { fields } = useFieldArray({
    control,
    name: `answer_contents.${index}.answer_evaluations`,
    keyName: "key",
  });
  const {
    field: {
      value: { content, extension_note },
    },
  } = useController({
    control,
    name: `answer_contents.${index}`,
  });
  const { t } = useTranslation();
  return (
    <div className=" flex flex-col gap-5 p-5">
      <div className=" text-base font-medium">
        {index + 1}、{content}
      </div>
      <AnswerRadioGroup index={index} />
      <div className="text-cool-gray-500">
        {extension_note
          ? `${t("supplemental-information")} : ${extension_note}`
          : t("no-supplemental-information")}
      </div>
      <div className=" flex flex-col gap-4 p-4 rounded-md bg-cool-gray-50">
        <p className=" text-sm font-medium text-cool-gray-700">
          {t("assessor-check-items")}
        </p>
        {fields.map((field, evaluationIndex) => (
          <AssessorCheckItem
            key={field.key}
            contentIndex={index}
            evaluationIndex={evaluationIndex}
          />
        ))}
      </div>
    </div>
  );
}

export default AnswerContent;
